import { render, staticRenderFns } from "./ModalNovice.vue?vue&type=template&id=317ee8fd&scoped=true"
import script from "./ModalNovice.vue?vue&type=script&lang=js"
export * from "./ModalNovice.vue?vue&type=script&lang=js"
import style0 from "./ModalNovice.vue?vue&type=style&index=0&id=317ee8fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317ee8fd",
  null
  
)

export default component.exports